import { CareQualityMeasuresChartProps } from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/CareQualityMeasuresChart';
import axios from 'axios';
import properties from '../properties';
import {
  capitalizeString,
  decryptData,
  numberToCurrencyFormatter,
  numFormatterWithSuffix,
} from './helper';
import {
  formatCostValues,
  formatGenderValues,
  formatMemberValues,
  formatPEPM,
  formatPMPM,
  formatTotalCost,
} from './summaryReportHelper';
import {
  formatMemberClaim,
  getTextWithToolTip,
} from './riskPatientDetailsHelper';
import { getEnrollemntStatusChip } from './riskProfileHelper';
import MedicalHistoryDetails from '../../_components/organisms/MedicalHistoryDetails';
import React from 'react';

export interface MemberDetailsType {
  memberId: string;
  recentVisit: string;
  chronicConditions: string;
  diagnosis: string;
  triggerConditions: string;
  previousYearCost: string | number;
  cost: string | number;
}

export interface CostTrendXAxisType {
  label: string;
}

export interface CostTrendChartType {
  medicalClaimsData: CostTrendDataType[];
  medicalTotalPaid: CostTrendDataType[];
  rxTotalPaid: CostTrendDataType[];
  rxClaims: CostTrendDataType[];
  xAxis: CostTrendXAxisType[];
}

export interface CostTrendDataType {
  month: string;
  value: string;
}

export const getTotalCost = async (
  requestBody: any,
  setTotalCost: any,
  setCostValues?: any,
  setMemberValues?: any,
) => {
  await axios
    .post(properties.aiqBaseUrl + properties.summaryBaseUrl, requestBody)
    .then((res) => {
      if (res?.status === 200) {
        const formattedData = formatTotalCost(res?.data?.data, 2);
        setTotalCost(formattedData);
        setCostValues ? setCostValues(formatCostValues(res?.data?.data)) : '';
        setMemberValues
          ? setMemberValues(formatMemberValues(res?.data?.data))
          : '';
      }
    })
    .catch((error) => {
      return error;
    });
};

export const getTotalCostWithGenderAndAge = async (
  requestBody: any,
  setTotalCost: any,
  setCostValues?: any,
  setMemberValues?: any,
  setAvgAge?: any,
  setGenderData?: any,
) => {
  await axios
    .post(properties.aiqBaseUrl + properties.summaryBaseUrl, requestBody)
    .then((res) => {
      if (res?.status === 200) {
        setAvgAge(res?.data?.data?.avgAge ?? 0);
        setGenderData(formatGenderValues(res?.data?.data?.totalEnrollesCount));
        const formattedData = formatTotalCost(res?.data?.data, 2);
        setTotalCost(formattedData);
        setCostValues ? setCostValues(formatCostValues(res?.data?.data)) : '';
        setMemberValues
          ? setMemberValues(formatMemberValues(res?.data?.data))
          : '';
      }
    })
    .catch((error) => {
      return error;
    });
};

export const getPMPM = async (requestBody: any, setPMPM: any) => {
  await axios
    .post(
      properties.aiqBaseUrl + properties.summaryBaseUrl + properties.pmpm,
      requestBody,
    )
    .then((res) => {
      if (res?.status === 200) {
        const formattedData = formatPMPM(res?.data?.data);
        setPMPM(formattedData);
      }
    })
    .catch((error) => {
      return error;
    });
};

export const getPMPMandPEPM = async (
  requestBody: any,
  setPMPM: any,
  setPEPM: any,
) => {
  await axios
    .post(
      properties.aiqBaseUrl +
        properties.summaryBaseUrl +
        properties.pmpmAndPepm,
      requestBody,
    )
    .then((res) => {
      if (res?.status === 200) {
        setPMPM(formatPMPM(res?.data?.data?.pmpm));
        setPEPM(formatPEPM(res?.data?.data?.pepm));
      }
    })
    .catch((error) => {
      return error;
    });
};

export const getPEPM = async (requestBody: any, setPEPM: any) => {
  await axios
    .post(
      properties.aiqBaseUrl + properties.summaryBaseUrl + properties.pepm,
      requestBody,
    )
    .then((res) => {
      if (res?.status === 200) {
        const formattedData = formatPEPM(res?.data.data);
        setPEPM(formattedData);
      }
    })
    .catch((error) => {
      return error;
    });
};

export const getCostTrend = async (requestBody: any, setCostTrend: any) => {
  await axios
    .post(
      properties.aiqBaseUrl + properties.summaryBaseUrl + properties.costTrend,
      requestBody,
    )
    .then((res) => {
      if (res?.status === 200) {
        setCostTrend(formatCostTrend(res?.data?.data?.costTrend));
      }
    })
    .catch((error) => {
      return error;
    });
};
export const formatCostTrend = (data: any) => {
  const CostTrendChartType: CostTrendChartType = {
    medicalClaimsData: [],
    medicalTotalPaid: [],
    rxTotalPaid: [],
    rxClaims: [],
    xAxis: [],
  };
  const monthAxis: any = [];
  data?.map((item: any) => {
    if (item.claim_type === 'rx') {
      const tempRxPaid: CostTrendDataType = {
        month: '',
        value: '',
      };
      tempRxPaid.month = item.month;
      tempRxPaid.value = item.total_cost;

      CostTrendChartType.rxTotalPaid.push(tempRxPaid);

      const tempRxClaims: CostTrendDataType = {
        month: '',
        value: '',
      };
      tempRxClaims.month = item.month;
      tempRxClaims.value = item.total_claims;

      CostTrendChartType.rxClaims.push(tempRxClaims);
    }
    if (item.claim_type === 'medical') {
      const tempMedicalPaid: CostTrendDataType = {
        month: '',
        value: '',
      };
      tempMedicalPaid.month = item.month;
      tempMedicalPaid.value = item.total_cost;

      CostTrendChartType.medicalTotalPaid.push(tempMedicalPaid);

      const tempMedicalClaims: CostTrendDataType = {
        month: '',
        value: '',
      };
      tempMedicalClaims.month = item.month;
      tempMedicalClaims.value = item.total_claims;

      CostTrendChartType.medicalClaimsData.push(tempMedicalClaims);
    }
    const monthArray = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const monthLabel = `${monthArray[item.month - 1]} <br/> ${item.year}`;
    if (!monthAxis.includes(monthLabel)) {
      monthAxis.push(monthLabel);
      CostTrendChartType.xAxis.push({ label: monthLabel });
    }
  });
  return CostTrendChartType;
};

export const getMembersDetails = async (
  requestBody: any,
  setMembersDetails: any,
  setMemberDetailsLoading: any,
) => {
  setMemberDetailsLoading(true);
  await axios
    .post(properties.aiqBaseUrl + properties.membersList, requestBody)
    .then((res) => {
      if (res?.status === 200) {
        setMembersDetails(
          formatMembersDetails(res?.data?.data?.memberList, true),
        );
      }
      setMemberDetailsLoading(false);
    })
    .catch((error) => {
      setMemberDetailsLoading(false);
      return error;
    });
};

export const deductibleMemberDetails = async (
  requestBody: any,
  setMemberDetails: any,
  setMemberDetailsLoading: any,
) => {
  setMemberDetailsLoading(true);
  axios
    .post(properties.aiqBaseUrl + properties.deductiblePatientList, requestBody)
    .then((res: any) => {
      if (res?.status === 200) {
        setMemberDetails(formatDeductibleMembersDetails(res?.data?.data));
      }
      setMemberDetailsLoading(false);
    })
    .catch((error) => {
      setMemberDetailsLoading(false);
      return error;
    });
};

export const formatDeductibleMembersDetails = (data: any) => {
  const tableData: any = [];

  data?.map((item: any) => {
    const tempRowData = {
      memberId: '',
      chronicConditions: '',
      planPaid: '',
      specPercent: '',
    };
    const arrayToString = (data: string[]) => {
      let str = '';
      data?.map((item, index) => {
        str += item + (data?.length - 1 !== index ? ' | ' : '');
      });
      return str;
    };
    if (item.member_unique_id !== '' || null) {
      tempRowData.memberId = item.member_unique_id;
      tempRowData.chronicConditions = arrayToString(item.chronic_conditions);
      tempRowData.planPaid = numberToCurrencyFormatter(
        item.plan_paid_amount,
        true,
        2,
      );
      tempRowData.specPercent = item.spec_percent + '%';
      tableData.push(tempRowData);
    }
  });

  return tableData;
};

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });
};

export const formatPlanDates = (data: any) => {
  return {
    incurredStart: formatDate(data.incurred_start_date),
    incurredEnd: formatDate(data.incurred_end_date),
    paidStart: formatDate(data.paid_start_date),
    paidEnd: formatDate(data.paid_end_date),
  };
};

export const formatNewMembersListsData = (
  data: any[],
  memberIdentification: boolean,
) => {
  const tableData: any[] = [];

  data?.forEach((item: any) => {
    const eachRow: any[] = [];

    eachRow[0] = item?.member_unique_id;
    if (memberIdentification) {
      eachRow.push(item.patient_name ? decryptData(item.patient_name) : '-');
    }
    eachRow.push(getEnrollemntStatusChip(item?.enrollment_status));

    // const conditions = item?.chronic_conditions.filter(
    //   (temp: any) => temp !== null,
    // );
    // eachRow.push(conditions?.length ? getTextWithToolTip(conditions, 30) : '-');

    eachRow.push(
      getTextWithToolTip(
        item.diagnosis.map((val: any) => {
          return `${val.diagnosis_desc} - ${numberToCurrencyFormatter(
            val.diagnosis_plan_paid,
          )}`;
        }),
        30,
      ),
    );

    eachRow.push(
      getTextWithToolTip(
        `${numberToCurrencyFormatter(item?.plan_paid_amount, true)}`,
        20,
      ),
    );

    eachRow.push(item.spec_percent + '%');

    eachRow.push(
      <MedicalHistoryDetails
        riskPatientDetails={formatMemberClaim(
          item?.claimData,
          item?.member_unique_id,
        )}
      />,
    );

    tableData.push(eachRow);
  });

  return tableData;
};

export const formatMembersDetails = (
  data: any,
  showFullAmountWithDollar?: boolean,
) => {
  const tableData: MemberDetailsType[] = [];
  data?.map((item: any) => {
    const tempRowData: MemberDetailsType = {
      memberId: '',
      recentVisit: '',
      chronicConditions: '',
      diagnosis: '',
      triggerConditions: '',
      previousYearCost: '',
      cost: '',
    };
    const arrayToString = (data: string[]) => {
      let str = '';
      data?.map((item, index) => {
        str += item + (data?.length - 1 !== index ? ' | ' : '');
      });
      return str;
    };
    if (item['Member ID'] !== '' || null) {
      tempRowData.memberId = item['Member ID'];
      tempRowData.recentVisit = item['Recent Visit'];
      tempRowData.chronicConditions = arrayToString(
        item['Chronic Conditions'].filter((temp: any) => temp !== null),
      );
      tempRowData.diagnosis = `${item['Diagnosis']?.map((val: any) => {
        return `${val?.diagnosis_desc} - ${numberToCurrencyFormatter(
          val?.diagnosis_total_paid,
        )}`;
      })}`;
      tempRowData.triggerConditions = arrayToString(
        item['Trigger Conditions'].filter((temp: any) => temp !== '-'),
      );
      tempRowData.cost = showFullAmountWithDollar
        ? numberToCurrencyFormatter(item['Total Cost'], true, 2)
        : numFormatterWithSuffix(item['Total Cost'], 2);
      tempRowData.previousYearCost = showFullAmountWithDollar
        ? !isNaN(item['Previous Year Cost']) &&
          item['Previous Year Cost'] !== '-'
          ? numberToCurrencyFormatter(item['Previous Year Cost'], true, 2)
          : item['Previous Year Cost']
        : !isNaN(item['Previous Year Cost']) &&
          item['Previous Year Cost'] !== '-'
        ? numFormatterWithSuffix(item['Previous Year Cost'], 2)
        : item['Previous Year Cost'];
      tableData.push(tempRowData);
    }
  });

  return tableData;
};

export const formatMembersListsData = (data: any) => {
  const tableData: any = [];

  data?.map((item: any) => {
    const tempRowData = {
      memberId: '',
      enrollmentStatus: '',
      chronicConditions: '',
      costliestDrugs: '',
      triggerConditions: '',
      previousYearCost: '',
      cost: '',
    };
    const arrayToString = (data: string[]) => {
      let str = '';
      data?.map((item, index) => {
        str += item + (data?.length - 1 !== index ? ' | ' : '');
      });
      return str;
    };
    if (item.member_unique_id !== '' || null) {
      tempRowData.memberId = item.member_unique_id;
      tempRowData.enrollmentStatus = item.enrollment_status;
      tempRowData.chronicConditions = arrayToString(item.chronic_conditions);
      tempRowData.costliestDrugs = item.costliest_drugs;
      tempRowData.triggerConditions = arrayToString(item.trigger_conditions);
      tempRowData.cost = `${numberToCurrencyFormatter(
        item?.cost,
        true,
      )}(${numberToCurrencyFormatter(
        item?.med_paid,
        true,
      )} + ${numberToCurrencyFormatter(item?.rx_paid, true)})`;
      tempRowData.previousYearCost = `${numberToCurrencyFormatter(
        item?.previous_year_cost?.total_cost,
        true,
      )}(${numberToCurrencyFormatter(
        item?.previous_year_cost?.med_paid,
        true,
      )} + ${numberToCurrencyFormatter(
        item?.previous_year_cost?.rx_paid,
        true,
      )})`;
      tableData.push(tempRowData);
    }
  });

  return tableData;
};

export const costTrendXAxis = [
  { label: 'Jan <br/> 2021' },
  { label: 'Feb <br/> 2021' },
  { label: 'Mar <br/> 2021' },
  { label: 'Apr <br/> 2021' },
  { label: 'May <br/> 2021' },
  { label: 'Jun <br/> 2021' },
  { label: 'Jul <br/> 2021' },
  { label: 'Aug <br/> 2021' },
  { label: 'Sep <br/> 2021' },
  { label: 'Oct <br/> 2021' },
  { label: 'Nov <br/> 2021' },
  { label: 'Dec <br/> 2021' },
];

export const getCareQualityMeasures = async (
  requestBody: any,
  setCareQualityMeasures: any,
) => {
  await axios
    .post(
      properties.aiqBaseUrl +
        properties.memberSummaryBaseUrl +
        properties.careQualityMeasures,
      requestBody,
    )
    .then((res) => {
      if (res?.status === 200) {
        const formattedData = formatCareQualityMeasures(res?.data?.data);
        setCareQualityMeasures(formattedData);
      }
    })
    .catch((error) => {
      return error;
    });
};

export const formatCareQualityMeasures = (data: any) => {
  const careQualityMeasuresData: CareQualityMeasuresChartProps = {
    categories: [],
    metPopulationData: [],
    unMetPopulation: [],
  };

  data.sort((a: any, b: any) => b.measureNotMetCount - a.measureNotMetCount);

  data?.map((item: any) => {
    const tempLabel = { label: item.measure };
    const tempMetValue = { value: item.measureMetCount };
    const tempUnMetValue = { value: item.measureNotMetCount };
    careQualityMeasuresData?.categories.push(tempLabel);
    careQualityMeasuresData?.metPopulationData.push(tempMetValue);
    careQualityMeasuresData?.unMetPopulation.push(tempUnMetValue);
  });

  return careQualityMeasuresData;
};

export const getTopDiagnosis = async (
  requestBody: any,
  type: 'cost' | 'member',
  setTopDiagnosis: any,
  setDiagnosisLoader: any,
  setTotalPagesForTopMedicationsAndDiagnosis?: any,
  isDiseasePrevalence?: boolean,
  isChronicPrevalence?: boolean,
) => {
  let url = '';
  if (isDiseasePrevalence) {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.diseasePrevalence +
          properties.diseasePrevalenceByCost
        : properties.aiqBaseUrl +
          properties.diseasePrevalence +
          properties.diseasePrevalenceByMember;
  } else if (isChronicPrevalence) {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.chronicPrevalence +
          properties.diseasePrevalenceByCost
        : properties.aiqBaseUrl +
          properties.chronicPrevalence +
          properties.diseasePrevalenceByMember;
  } else {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.memberSummaryBaseUrl +
          properties.diagnosisByCost
        : properties.aiqBaseUrl +
          properties.memberSummaryBaseUrl +
          properties.diagnosisByMember;
  }
  setDiagnosisLoader(true);
  await axios
    .post(url, requestBody)
    .then((res) => {
      if (res?.status === 200) {
        const formattedData = formatTopDiagnosis(res?.data?.data?.topDiagnosis);
        setTopDiagnosis(formattedData);
        setTotalPagesForTopMedicationsAndDiagnosis(
          Math.ceil(res?.data?.data?.totalCount / 5),
        );
      }
      setDiagnosisLoader(false);
    })
    .catch((error) => {
      setDiagnosisLoader(false);
      return error;
    });
};

export const formatTopDiagnosis = (data: any) => {
  const tableData: any[] = [];

  data?.map((item: any) => {
    const tempRowData = [];
    if (item.chronicDiseaseName !== '' || null) {
      tempRowData.push(
        item.chronicDiseaseName.length > 50
          ? getTextWithToolTip(item.chronicDiseaseName, 50)
          : item.chronicDiseaseName,
      );
      tempRowData.push(item.chronicDiseasePercent.toFixed(2) + '%');
      tableData.push(tempRowData);
    }
  });

  return tableData;
};

export const getTopProcedures = async (
  requestBody: any,
  type: 'cost' | 'member',
  setTopProcedures: any,
  setProceduresLoader: any,
  setTotalPagesForTopProceduresAndProviders?: any,
  isDiseasePrevalence?: boolean,
  isChronicPrevalence?: boolean,
) => {
  let url = '';
  if (isDiseasePrevalence) {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.diseasePrevalence +
          properties.proceduresByCost
        : properties.aiqBaseUrl +
          properties.diseasePrevalence +
          properties.proceduresByMember;
  } else if (isChronicPrevalence) {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.chronicPrevalence +
          properties.proceduresByCost
        : properties.aiqBaseUrl +
          properties.chronicPrevalence +
          properties.proceduresByMember;
  } else {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.memberSummaryBaseUrl +
          properties.proceduresByCost
        : properties.aiqBaseUrl +
          properties.memberSummaryBaseUrl +
          properties.proceduresByMember;
  }
  setProceduresLoader(true);
  await axios
    .post(url, requestBody)
    .then((res) => {
      if (res?.status === 200) {
        const formattedData = formatTopProcedures(res?.data?.data?.procedures);
        setTopProcedures(formattedData);
        setTotalPagesForTopProceduresAndProviders(
          Math.ceil(res?.data?.data?.totalCount / 5),
        );
      }
      setProceduresLoader(false);
    })
    .catch((error) => {
      setProceduresLoader(false);
      return error;
    });
};

export const formatTopProcedures = (data: any) => {
  const tableData: any[] = [];

  data?.map((item: any) => {
    const tempRowData = [];
    if (item.procedure !== '' || null) {
      tempRowData.push(
        item.procedure.length > 50
          ? getTextWithToolTip(item.procedure, 50)
          : item.procedure,
      );
      tempRowData.push(item.procedurePercent.toFixed(2) + '%');
      tableData.push(tempRowData);
    }
  });

  return tableData;
};

export const getTopProviders = async (
  requestBody: any,
  type: 'cost' | 'member',
  setTopProviders: any,
  setProvidersLoader: any,
  setTotalPagesForTopProceduresAndProviders?: any,
  isDiseasePrevalence?: boolean,
  isChronicPrevalence?: boolean,
) => {
  let url = '';
  if (isDiseasePrevalence) {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.diseasePrevalence +
          properties.providersByCost
        : properties.aiqBaseUrl +
          properties.diseasePrevalence +
          properties.providersByMember;
  } else if (isChronicPrevalence) {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.chronicPrevalence +
          properties.providersByCost
        : properties.aiqBaseUrl +
          properties.chronicPrevalence +
          properties.providersByMember;
  } else {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.memberSummaryBaseUrl +
          properties.providersByCost
        : properties.aiqBaseUrl +
          properties.memberSummaryBaseUrl +
          properties.providersByMember;
  }
  setProvidersLoader(true);
  await axios
    .post(url, requestBody)
    .then((res) => {
      if (res?.status === 200) {
        const formattedData = formatTopProviders(res?.data?.data?.topProviders);
        setTopProviders(formattedData);
        setTotalPagesForTopProceduresAndProviders(
          Math.ceil(res?.data?.data?.totalCount / 5),
        );
      }
      setProvidersLoader(false);
    })
    .catch((error) => {
      setProvidersLoader(false);
      return error;
    });
};

export const formatTopProviders = (data: any) => {
  const tableData: any[] = [];

  data?.map((item: any) => {
    const tempRowData = [];
    if (item.procedure !== '' || null) {
      tempRowData.push(
        item.provider.length > 50
          ? getTextWithToolTip(capitalizeString(item.provider), 50)
          : capitalizeString(item.provider),
      );
      tempRowData.push(item.providerPercent.toFixed(2) + '%');
      tableData.push(tempRowData);
    }
  });

  return tableData;
};

export const getTopMedications = async (
  requestBody: any,
  type: 'cost' | 'member',
  setTopMedications: any,
  setMedicationsLoader: any,
  setTotalPagesForTopMedicationsAndDiagnosis?: any,
  isDiseasePrevalence?: boolean,
  isChronicPrevalence?: boolean,
) => {
  let url = '';
  if (isDiseasePrevalence) {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.diseasePrevalence +
          properties.topMedicationByCost
        : properties.aiqBaseUrl +
          properties.diseasePrevalence +
          properties.topMedicationByMember;
  } else if (isChronicPrevalence) {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.chronicPrevalence +
          properties.topMedicationByCost
        : properties.aiqBaseUrl +
          properties.chronicPrevalence +
          properties.topMedicationByMember;
  } else {
    url =
      type === 'cost'
        ? properties.aiqBaseUrl +
          properties.summaryBaseUrl +
          properties.pharmacyUsageByCost
        : properties.aiqBaseUrl +
          properties.summaryBaseUrl +
          properties.pharmacyUsageByMember;
  }
  setMedicationsLoader(true);
  await axios
    .post(url, requestBody)
    .then((res) => {
      if (res?.status === 200) {
        const formattedData = formatTopMedications(
          res?.data?.data?.topMedications,
          type,
        );
        setTopMedications(formattedData);
        setTotalPagesForTopMedicationsAndDiagnosis(
          Math.ceil(res?.data?.data?.totalCount / 5),
        );
      }
      setMedicationsLoader(false);
    })
    .catch((error) => {
      setMedicationsLoader(false);
      return error;
    });
};

export const formatTopMedications = (data: any, type: 'cost' | 'member') => {
  const tableData: any[] = [];

  data?.map((item: any) => {
    const tempRowData = [];

    tempRowData.push(
      item.medication.length > 50
        ? getTextWithToolTip(item.medication, 50)
        : item.medication,
    );
    tempRowData.push(
      type === 'cost'
        ? item.totalCostRatio.toFixed(2) + '%'
        : item.totalMembersRatio.toFixed(2) + '%',
    );
    tableData.push(tempRowData);
  });

  return tableData;
};
export const getDropdownValue = (dropDownText: string) => {
  switch (dropDownText) {
    case 'Diagnosis by Cost':
      return 'diagnosis by cost';

    case 'Medications by Cost':
      return 'medications by cost';

    case 'Medications by Member':
      return 'medications by member volume';

    case 'Diagnosis by Member':
      return 'diagnosis by member volume';

    case 'Procedures by Cost':
      return 'procedures by cost';

    case 'Providers by Cost':
      return 'providers by cost';

    case 'Providers by Member':
      return 'providers by member volume';

    case 'Procedures by Member':
      return 'procedures by member volume';
    default:
      return '';
  }
};

export const getMemberData = async (requestBody: any, setMemberData: any) => {
  await axios
    .post(
      properties.aiqBaseUrl +
        properties.careQualityBasicUrl +
        properties.summary,
      requestBody,
    )
    .then((res) => {
      if (res?.status === 200) {
        setMemberData(res?.data?.data);
      }
    })
    .catch((error) => {
      return error;
    });
};
